import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import _ from 'lodash'
import { GatsbyImage } from 'gatsby-plugin-image'
import {
  FaFacebookF,
  FaInstagram,
  FaBloggerB,
  FaYoutube,
  FaSpotify,
  FaTiktok,
} from 'react-icons/fa'
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa'

// Import typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

// App components
import CustomLink from '../components/CustomLink'

// App content
import { FreeConsultForm } from '../components/FreeConsultForm'
import tiktok from '../assets/social/tiktok.png'

// App utils
import config from '../utils/config'
import { rhythm } from '../utils/typography'
import { themeStyles, colors } from '../utils/theme'

const styles = {
  iconWrapper: {
    backgroundColor: colors.brightBlue,
    height: '40px',
    width: '40px',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: rhythm(1 / 2),
  },
  elementWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: rhythm(1 / 2),
  },
  link: {
    cursor: 'pointer',
    color: 'white',
    textDecoration: 'none',
    fontWeight: 'normal',
  },
  footerImageHolder: {},
  footerImage: {
    maxHeight: '50px',
    display: 'block',
    margin: 0,
  },
}

const SocialBar = () => {
  const iconOuterStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '100%',
    backgroundColor: '#',
  }
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '350px',
        justifyContent: 'space-between',
      }}
    >
      <CustomLink
        target="_blank"
        href={config.socialLinks.tiktok}
        style={iconOuterStyle}
      >
        <FaTiktok color="#00afd7" size="20" />
      </CustomLink>
      <CustomLink
        target="_blank"
        href={config.socialLinks.instagram}
        style={iconOuterStyle}
      >
        <FaInstagram color="#00afd7" size="20" />
      </CustomLink>
      <CustomLink
        target="_blank"
        href={config.socialLinks.youtube}
        style={iconOuterStyle}
      >
        <FaYoutube color="#00afd7" size="20" />
      </CustomLink>
      <CustomLink
        target="_blank"
        href={config.socialLinks.facebook}
        style={iconOuterStyle}
      >
        <FaFacebookF color="#00afd7" size="20" />
      </CustomLink>
      <CustomLink
        target="_blank"
        href={config.socialLinks.spotify}
        style={iconOuterStyle}
      >
        <FaSpotify color="#00afd7" size="20" />
      </CustomLink>
      <CustomLink
        target="_blank"
        href={config.socialLinks.blogger}
        style={iconOuterStyle}
      >
        <FaBloggerB color="#00afd7" size="20" />
      </CustomLink>
    </div>
  )
}

class Footer extends React.Component {
  render() {
    const { AAO, ABO, Invisalign, PatientLoginButton, PatientScheduleButton } =
      this.props.data
    return (
      <div id="footer-div">
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            backgroundColor: '#1a1a1a',

            paddingBottom: rhythm(1),
          }}
        >
          <div css={{ marginTop: '50px' }}></div>
          <div
            css={{
              display: 'flex',
              flexDirection: 'row',
              gap: '25px',
              marginBottom: '25px',
              flex: 1,
              flexWrap: 'wrap',
              ...themeStyles.textPadding,
            }}
          >
            <CustomLink
              target="_blank"
              href="https://edgeportal5.ortho2.com/full/Login.aspx?custident=1c432720-3e24-4d81-b38a-f03fa4fd877e&cookieCheck=true"
            >
              <GatsbyImage
                image={PatientLoginButton.childImageSharp.gatsbyImageData}
                css={{
                  maxWidth: '200px',
                }}
                alt="Patient Login"
                key="PatientLoginButton"
              />
            </CustomLink>
            <CustomLink href="https://www.rochesterorthodontics.com/the-next-step/schedule-a-free-consult">
              <GatsbyImage
                image={PatientScheduleButton.childImageSharp.gatsbyImageData}
                css={{
                  maxWidth: '200px',
                }}
                alt="Patient Schedule Appointment"
                key="PatientScheduleButton"
              />
            </CustomLink>
          </div>

          <div
            id="contact-info-div"
            css={{
              marginBottom: '25px',
            }}
          >
            <div css={{ color: '#fff', marginBottom: '10px' }}>
              <a
                css={{
                  color: '#fff',
                  textDecoration: 'none',
                  fontWeight: '400',
                }}
                href="https://maps.app.goo.gl/i1xfLwEXGd2Dkqeo6"
                target="_blank"
              >
                2946 Jeremiah Ln NW, Rochester, MN, 55901
              </a>
            </div>
            <div
              id="phone-email-div"
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <div>
                <span>
                  <a
                    css={{
                      color: '#00afd7',
                      textDecoration: 'none',
                      fontWeight: '400',
                      paddingRight: '10px',
                    }}
                    href="tel:15072585400"
                  >
                    (507) 258-5400
                  </a>
                </span>{' '}
                <span css={{ color: '#fff', paddingRight: '10px' }}>|</span>{' '}
                <a
                  css={{
                    color: '#fff',
                    textDecoration: 'none',
                    fontWeight: '400',
                  }}
                  href="mailto:info@rochesterorthodontics.com"
                >
                  info@rochesterorthodontics.com
                </a>
              </div>
            </div>
          </div>
          <div id="social-icons-div">
            <SocialBar />
          </div>
          <div css={{ marginBottom: '50px' }}></div>
        </div>
        <div
          css={{
            width: '100%',
            padding: rhythm(1),
            backgroundColor: colors.lightGrey,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            css={{
              ...themeStyles.innerText,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              width: '100%',
              justifyContent: 'space-around',
              maxWidth: '500px',
              flexWrap: 'wrap',
            }}
          >
            <CustomLink href="https://www.aaoinfo.org/">
              <GatsbyImage
                image={AAO.childImageSharp.gatsbyImageData}
                css={styles.footerImage}
                alt="AAO Info"
                key="AAO"
              />
            </CustomLink>
            <CustomLink href="https://www.americanboardortho.com/">
              <GatsbyImage
                image={ABO.childImageSharp.gatsbyImageData}
                css={styles.footerImage}
                alt="American Board Ortho"
                key="ABO"
              />
            </CustomLink>
            <CustomLink href="http://www.invisalign.com">
              <GatsbyImage
                image={Invisalign.childImageSharp.gatsbyImageData}
                css={styles.footerImage}
                alt="Invisalign"
                key="Invisalign"
              />
            </CustomLink>
          </div>
        </div>
      </div>
    )
  }
}

const FooterWithQuery = (props) => (
  <StaticQuery
    query={graphql`
      query FooterQuery {
        AAO: file(relativePath: { eq: "AAO.png" }) {
          ...fixedImage40Height
        }
        ABO: file(relativePath: { eq: "abo.png" }) {
          ...fixedImage40Height
        }
        Invisalign: file(relativePath: { eq: "logo-invisalign-color.png" }) {
          ...fixedImage40Height
        }
        PatientLoginButton: file(
          relativePath: { eq: "Footer_Button_Login.png" }
        ) {
          ...fixedImage50Height
        }
        PatientScheduleButton: file(
          relativePath: { eq: "Footer_Button_Schedule.png" }
        ) {
          ...fixedImage50Height
        }
      }
    `}
    render={(data) => <Footer {...props} data={data} />}
  />
)

export default FooterWithQuery
